import { render, staticRenderFns } from "./KeywordAttributes.vue?vue&type=template&id=82eb9b98&scoped=true"
import script from "./KeywordAttributes.vue?vue&type=script&lang=js"
export * from "./KeywordAttributes.vue?vue&type=script&lang=js"
import style0 from "./KeywordAttributes.vue?vue&type=style&index=0&id=82eb9b98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82eb9b98",
  null
  
)

export default component.exports